var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "dl",
      {
        staticClass:
          "padding-top-md padding-bottom-xl padding-left-5xl padding-right-2xl margin-0 display-flex flex-row flex-items-center flex-wrap",
        staticStyle: {
          gap: "var(--spacing-md)",
          "border-top": "var(--border-width-sm) solid var(--fa-dk-navy)",
          "--link-color": "var(--fa-blue)",
          "--link-hover-color": "var(--white)",
          "--list-line-height": "1.2",
        },
      },
      [
        _c(
          "dt",
          {
            staticClass: "margin-y-0 margin-right-0 size-sm",
            staticStyle: {
              "font-weight": "var(--font-weight-normal)",
              "margin-left": "calc(var(--spacing-3xl) * -1)",
            },
          },
          [
            _c("font-awesome-icon", {
              staticStyle: { color: "var(--fa-blue)" },
              attrs: { icon: _vm.$v7.solid.faCircleInfo, size: "lg" },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "sr-only margin-left-2xs" }, [
              _vm._v("Learn about… "),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _vm._l(_vm.allLinks, function (link) {
          return _c(
            "dd",
            { key: link.label, staticClass: "margin-bottom-0 size-sm" },
            [
              link.external
                ? _c(
                    "a",
                    {
                      attrs: {
                        href: link.path + (link.hash || ""),
                        target: "_blank",
                        rel: "noopener noreferrer",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.trackLinkClick(link)
                        },
                      },
                    },
                    [_vm._v("\n        " + _vm._s(link.label) + "\n      ")]
                  )
                : _c(
                    "site-link",
                    {
                      attrs: {
                        to: _vm.getDocsPath(link, {
                          version: _vm.majorVersion,
                        }),
                      },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.trackLinkClick(link)
                        },
                      },
                    },
                    [_vm._v("\n        " + _vm._s(link.label) + "\n      ")]
                  ),
            ],
            1
          )
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }